var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.98 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports_Job_Advertising-icon",
    "data-name": "Reports Job Advertising-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports_Job_Advertising-icon-2",
    "data-name": "Reports Job Advertising-icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.31,1.6a5.08,5.08,0,0,1,5.07,5.07V33.33a5.07,5.07,0,0,1-5.07,5.07H6.67A5.08,5.08,0,0,1,1.6,33.33V6.67A5.08,5.08,0,0,1,6.67,1.6H33.31m0-1.6H6.67A6.67,6.67,0,0,0,0,6.67V33.33A6.67,6.67,0,0,0,6.67,40H33.31A6.67,6.67,0,0,0,40,33.33V6.67A6.67,6.67,0,0,0,33.31,0",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,34.26H29.6V13.53H33Zm-2.44-.91H32V14.44H30.51Z",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.17,34.26H12.82V22.64h3.35Zm-2.44-.91h1.53v-9.8H13.73Z",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.77,34.26H18.41v-10h3.36Zm-2.45-.91h1.53V25.19H19.32Z",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.36,34.26H24V19.46h3.36Zm-2.44-.91h1.53v-13H24.92Z",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.44,17.2l-.18.44-.16.41-2.87,7-.17.43L8.88,26A1.67,1.67,0,0,0,8,25.62l.17-.44.18-.43,2.86-7h0l.16-.41.18-.42a1.76,1.76,0,0,0,.85.32",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.58,18.71a1.76,1.76,0,0,0-.51.75l-.4-.26L17.29,19l-2.57-1.7L14.35,17l-.4-.26a1.69,1.69,0,0,0,.52-.74l.39.26.37.24,2.57,1.7.38.25Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.19,10.11l-.34.34-.32.34-7.44,7.65-.32.33-.32.33a1.76,1.76,0,0,0-.68-.62l.33-.34.33-.34,7.44-7.65.31-.32.33-.34a1.76,1.76,0,0,0,.68.62",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06,25.51a2.43,2.43,0,0,0-.85-.33,2,2,0,0,0-.43,0,2.31,2.31,0,1,0,2.35,2.31,2.29,2.29,0,0,0-1.07-1.94M7.78,29.3a1.86,1.86,0,1,1,0-3.71,1.09,1.09,0,0,1,.26,0,1.67,1.67,0,0,1,.84.33,1.8,1.8,0,0,1,.79,1.5A1.88,1.88,0,0,1,7.78,29.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23,25.08a2.68,2.68,0,0,0-.84-.33,2.43,2.43,0,0,0-.61-.07,2.77,2.77,0,1,0,2.81,2.77,2.73,2.73,0,0,0-1.36-2.37M7.78,29.3a1.86,1.86,0,1,1,0-3.71,1.09,1.09,0,0,1,.26,0,1.67,1.67,0,0,1,.84.33,1.8,1.8,0,0,1,.79,1.5A1.88,1.88,0,0,1,7.78,29.3",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7,12.6a2.78,2.78,0,0,0-2.8,2.76,2.73,2.73,0,0,0,1.35,2.35h0a2.64,2.64,0,0,0,.85.33,2.35,2.35,0,0,0,.6.07,2.8,2.8,0,0,0,2.53-1.62,2.68,2.68,0,0,0,.25-1.14A2.78,2.78,0,0,0,12.7,12.6M14.47,16a1.69,1.69,0,0,1-.52.74,1.83,1.83,0,0,1-1.25.49,1.09,1.09,0,0,1-.26,0,1.76,1.76,0,0,1-.85-.32,1.84,1.84,0,0,1-.8-1.52,1.9,1.9,0,0,1,3.8,0,1.73,1.73,0,0,1-.12.64",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.77,18.77l-.32.33a1.76,1.76,0,0,0-.68-.62,1.82,1.82,0,0,0-.93-.25,1.9,1.9,0,0,0-1.26.48,1.76,1.76,0,0,0-.51.75l-.4-.26a2.43,2.43,0,0,1,.51-.75,2.38,2.38,0,0,1,1.66-.68,2.27,2.27,0,0,1,1.26.37,2.13,2.13,0,0,1,.67.63",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.43,17.8a2.87,2.87,0,0,0-1.59-.48,2.81,2.81,0,0,0-2,.88,2.76,2.76,0,0,0-.51.75l.38.25.4.26a1.76,1.76,0,0,1,.51-.75,1.9,1.9,0,0,1,1.26-.48,1.82,1.82,0,0,1,.93.25,1.76,1.76,0,0,1,.68.62l.32-.33.32-.33a2.68,2.68,0,0,0-.66-.64",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.65,20.09a2.81,2.81,0,0,1-5.61,0A2.75,2.75,0,0,1,17.29,19l.38.25.4.26a1.68,1.68,0,0,0-.12.63,1.9,1.9,0,0,0,3.79,0,1.83,1.83,0,0,0-.29-1l.32-.33.32-.33a2.65,2.65,0,0,1,.56,1.65",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.11,6.19A2.33,2.33,0,0,0,28.76,8.5a2.29,2.29,0,0,0,.42,1.33,2.33,2.33,0,0,0,.67.62,2.27,2.27,0,0,0,1.26.37,2.32,2.32,0,1,0,0-4.63m0,4.17a1.81,1.81,0,0,1-.92-.25,1.76,1.76,0,0,1-.68-.62,1.83,1.83,0,0,1-.29-1,1.9,1.9,0,1,1,1.89,1.86",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.11,5.73a2.79,2.79,0,0,0-2.8,2.77,2.84,2.84,0,0,0,1.22,2.29,2.83,2.83,0,0,0,1.58.48,2.77,2.77,0,1,0,0-5.54m0,4.63a1.81,1.81,0,0,1-.92-.25,1.76,1.76,0,0,1-.68-.62,1.83,1.83,0,0,1-.29-1,1.9,1.9,0,1,1,1.89,1.86",
    fill: "#58595b"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.3ec27174b1498e5a67aac208f6e5fbe8.svg";
export { ForwardRef as ReactComponent };